// src/components/Legal/About.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  const containerStyle = {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.6',
  };

  const sectionStyle = {
    marginBottom: '30px',
  };

  const headingStyle = {
    color: '#2980B9',
    marginTop: '30px',
    marginBottom: '15px',
  };

  const linkStyle = {
    color: '#2980B9',
    textDecoration: 'underline',
  };

  return (
    <div style={containerStyle}>
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <h1 style={{ color: '#2980B9' }}>
          <span style={{ color: "#2980B9" }}>cis</span>
          <span style={{ color: "#CE93D8" }}>fuss</span> - About Us
        </h1>
      </div>

      <div style={sectionStyle}>
        <p>
          Searching for a job can feel like a sisyphean task. <br />
          Cisfuss was created to simplify the process. <br />
          With thousands of jobs in the international sector, it can be hard to find the right opportunity for you. <br />
          We hope cisfuss helps jobseekers find jobs faster, cast a wider net, and not miss amazing opportunities.<br />
          And we hope it helps international organisations by connecting them with amazing, talented candidates.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>What We Do</h2>
        <p>
          We automatically collect, analyze, and organize job listings to provide a more user-friendly search experience. Our platform:
        </p>
        <ul>
          <li>Updates every few hours with the latest vacancies</li>
          <li>Uses AI to extract key information from job descriptions</li>
          <li>Provides powerful filtering options to help you find relevant opportunities</li>
          <li>Offers semantic search capabilities powered by AI</li>
          <li>Allows you to save interesting jobs to your personal profile</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>Our Commitment</h2>
        <p>
          We are committed to:
        </p>
        <ul>
          <li>Providing accurate and up-to-date information</li>
          <li>Continuously improving our platform based on user feedback</li>
          <li>Protecting your privacy and personal data</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>Disclaimer</h2>
        <p>
          Cisfuss is an independent service that aggregates publicly available job information. It is not affiliated with the institutions whose jobs are posted here. While we strive for accuracy, we recommend 
          always verifying job details on the original posting before applying.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>Contact Us</h2>
        <p>
          Have questions or feedback? We'd love to hear from you!
          <br />
          Email us at: <a href="mailto:contact@cisfuss.io" style={linkStyle}>contact@cisfuss.io</a>
        </p>
      </div>

      <div style={{ marginTop: '40px', textAlign: 'center' }}>
        <Link to="/" style={linkStyle}>Return to Dashboard</Link>
        {' | '}
        <Link to="/terms" style={linkStyle}>Terms of Service</Link>
        {' | '}
        <Link to="/privacy-policy" style={linkStyle}>Privacy Policy</Link>
      </div>
    </div>
  );
};

export default About;